var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { COLOR_TOKENS } from '../colors/colors';
import { SHADOWS } from '../shadows/shadows';
import { RADIUS, SPACING } from '../spacing/spacing';
import { TYPOGRAPHY_VARIANTS } from '../typography/typography';
var COMMON_BUTTON_SIZE_STYLES = {
    height: 'fit-content',
    minWidth: 'unset',
};
export var BUTTON_SIZES = {
    sm: {
        Default: __assign(__assign({ padding: "".concat(SPACING['spacing-md'], " ").concat(SPACING['spacing-lg']), gap: SPACING['spacing-xs'], borderRadius: RADIUS['radius-md'] }, COMMON_BUTTON_SIZE_STYLES), TYPOGRAPHY_VARIANTS['text-sm-semibold']),
        Leading: __assign(__assign({ padding: "".concat(SPACING['spacing-md'], " 14px"), gap: SPACING['spacing-md'], borderRadius: RADIUS['radius-md'] }, COMMON_BUTTON_SIZE_STYLES), TYPOGRAPHY_VARIANTS['text-sm-semibold']),
        Only: __assign(__assign({ padding: SPACING['spacing-md'], borderRadius: RADIUS['radius-md'] }, COMMON_BUTTON_SIZE_STYLES), TYPOGRAPHY_VARIANTS['text-sm-semibold']),
    },
    md: {
        Default: __assign(__assign({ padding: '10px 14px', gap: SPACING['spacing-xs'], borderRadius: RADIUS['radius-md'] }, COMMON_BUTTON_SIZE_STYLES), TYPOGRAPHY_VARIANTS['text-sm-semibold']),
        Leading: __assign(__assign({ padding: "10px ".concat(SPACING['spacing-xl']), gap: SPACING['spacing-md'], borderRadius: RADIUS['radius-md'] }, COMMON_BUTTON_SIZE_STYLES), TYPOGRAPHY_VARIANTS['text-sm-semibold']),
        Only: __assign(__assign({ padding: '10px', borderRadius: RADIUS['radius-md'] }, COMMON_BUTTON_SIZE_STYLES), TYPOGRAPHY_VARIANTS['text-sm-semibold']),
    },
    lg: {
        Default: __assign(__assign({ padding: "10px ".concat(SPACING['spacing-xl']), borderRadius: RADIUS['radius-md'], gap: SPACING['spacing-sm'] }, COMMON_BUTTON_SIZE_STYLES), TYPOGRAPHY_VARIANTS['text-md-semibold']),
        Leading: __assign(__assign({ padding: '10px 18px', borderRadius: RADIUS['radius-md'], gap: SPACING['spacing-md'] }, COMMON_BUTTON_SIZE_STYLES), TYPOGRAPHY_VARIANTS['text-md-semibold']),
        Only: __assign(__assign({ padding: SPACING['spacing-lg'], borderRadius: RADIUS['radius-md'] }, COMMON_BUTTON_SIZE_STYLES), TYPOGRAPHY_VARIANTS['text-md-semibold']),
    },
    xl: {
        Default: __assign(__assign({ padding: "".concat(SPACING['spacing-lg'], " 18px"), borderRadius: RADIUS['radius-md'], gap: SPACING['spacing-sm'] }, COMMON_BUTTON_SIZE_STYLES), TYPOGRAPHY_VARIANTS['text-md-semibold']),
        Leading: __assign(__assign({ padding: "".concat(SPACING['spacing-lg'], " ").concat(SPACING['spacing-3xl']), borderRadius: RADIUS['radius-md'], gap: SPACING['spacing-md'] }, COMMON_BUTTON_SIZE_STYLES), TYPOGRAPHY_VARIANTS['text-md-semibold']),
        Only: __assign(__assign({ padding: '14px', borderRadius: RADIUS['radius-md'] }, COMMON_BUTTON_SIZE_STYLES), TYPOGRAPHY_VARIANTS['text-md-semibold']),
    },
    '2xl': {
        Default: __assign(__assign({ padding: "".concat(SPACING['spacing-xl'], " 22px"), borderRadius: RADIUS['radius-lg'], gap: SPACING['spacing-md'] }, COMMON_BUTTON_SIZE_STYLES), TYPOGRAPHY_VARIANTS['text-lg-semibold']),
        Leading: __assign(__assign({ padding: "".concat(SPACING['spacing-xl'], " ").concat(SPACING['spacing-3xl']), borderRadius: RADIUS['radius-lg'], gap: SPACING['spacing-lg'] }, COMMON_BUTTON_SIZE_STYLES), TYPOGRAPHY_VARIANTS['text-lg-semibold']),
        Only: __assign(__assign({ padding: SPACING['spacing-xl'], borderRadius: RADIUS['radius-lg'] }, COMMON_BUTTON_SIZE_STYLES), TYPOGRAPHY_VARIANTS['text-lg-semibold']),
    },
};
var COMMON_HIERARCHY_STYLES = {
    fontFamily: 'Sarabun, sans-serif',
    transition: 'all 0.3s ease-in-out',
    textTransform: 'none',
    '& .MuiButton-startIcon': { margin: 0 },
    '& .MuiButton-endIcon': { margin: 0 },
    '&.Mui-disabled': {
        backgroundColor: COLOR_TOKENS['Colors/Background/bg-disabled'],
        color: COLOR_TOKENS['Colors/Foreground/fg-disabled'],
        border: "2px solid ".concat(COLOR_TOKENS['Colors/Border/border-disabled-subtle']),
        boxShadow: 'none',
        cursor: 'not-allowed',
        pointerEvents: 'none',
        opacity: '1 !important',
    },
};
export var BUTTON_HIERARCHY_STYLES = {
    Primary: __assign(__assign({}, COMMON_HIERARCHY_STYLES), { backgroundColor: COLOR_TOKENS['Brand/500'], color: COLOR_TOKENS['Colors/Text/text-white'], border: "2px solid ".concat(COLOR_TOKENS['Colors/Base/Black']), '&:hover': {
            boxShadow: SHADOWS['shadow-xl'],
            backgroundColor: COLOR_TOKENS['Brand/500'],
            color: COLOR_TOKENS['Colors/Text/text-white'],
            transform: 'translate(-2px, -2px)',
        }, '&:active': {
            outline: 'none',
            border: "2px solid ".concat(COLOR_TOKENS['Colors/Base/White']),
            boxShadow: '0px 0px 0px 2px black',
            transform: 'translate(0px, 0px)',
            transition: 'all 0s',
        } }),
    'Primary destructive': __assign(__assign({}, COMMON_HIERARCHY_STYLES), { backgroundColor: COLOR_TOKENS['Colors/Background/bg-error-solid'], color: COLOR_TOKENS['Colors/Text/text-white'], border: "2px solid ".concat(COLOR_TOKENS['Colors/Base/Black']), '&:hover': {
            boxShadow: SHADOWS['shadow-xl'],
            backgroundColor: COLOR_TOKENS['Error/700'],
            color: COLOR_TOKENS['Colors/Text/text-white'],
            transform: 'translate(-2px, -2px)',
        }, '&:active': {
            outline: 'none',
            border: "2px solid ".concat(COLOR_TOKENS['Colors/Base/White']),
            boxShadow: "0px 0px 0px 2px ".concat(COLOR_TOKENS['Colors/Base/Black']),
            transform: 'translate(0px, 0px)',
            transition: 'all 0s',
        } }),
    'Secondary gray': __assign(__assign({}, COMMON_HIERARCHY_STYLES), { backgroundColor: COLOR_TOKENS['Colors/Base/White'], color: COLOR_TOKENS['Colors/Text/text-secondary'], border: "1px solid ".concat(COLOR_TOKENS['Colors/Border/border-primary']), position: 'relative', '&:hover': {
            backgroundColor: COLOR_TOKENS['Gray/50'],
            color: COLOR_TOKENS['Gray/700'],
        }, '&:active': {
            outline: 'none',
            border: "1px solid ".concat(COLOR_TOKENS['Colors/Border/border-primary']),
            backgroundColor: COLOR_TOKENS['Colors/Base/White'],
            transition: 'all 0s',
            '&::before': {
                content: '""',
                position: 'absolute',
                inset: '-4px',
                borderRadius: 'inherit',
                border: "2px solid ".concat(COLOR_TOKENS['Colors/Base/White']),
                pointerEvents: 'none',
                zIndex: 1,
            },
            '&::after': {
                content: '""',
                position: 'absolute',
                inset: '-6px',
                borderRadius: RADIUS['radius-lg'],
                border: "3px solid ".concat(COLOR_TOKENS['Brand/500']),
                pointerEvents: 'none',
                zIndex: 1,
            },
        } }),
    'Tertiary color': __assign(__assign({}, COMMON_HIERARCHY_STYLES), { backgroundColor: 'transparent', color: COLOR_TOKENS['Brand/700'], border: 'none', transition: 'all 200ms linear', '&:hover': {
            backgroundColor: 'transparent',
            color: COLOR_TOKENS['Brand/600'],
        }, '&:active': {
            backgroundColor: 'transparent',
            color: COLOR_TOKENS['Brand/700'],
            transition: 'all 0s',
        } }),
    'Secondary color': __assign(__assign({}, COMMON_HIERARCHY_STYLES), { backgroundColor: COLOR_TOKENS['Colors/Base/White'], color: COLOR_TOKENS['Brand/700'], border: "1px solid ".concat(COLOR_TOKENS['Brand/300']), transition: 'all 200ms linear', '&:hover': {
            backgroundColor: COLOR_TOKENS['Brand/50'],
            color: COLOR_TOKENS['Brand/600'],
        }, '&:active': {
            backgroundColor: COLOR_TOKENS['Brand/100'],
            color: COLOR_TOKENS['Brand/700'],
            transition: 'all 0s',
        } }),
};
